import { memo } from 'react';
import { errToast, succToast, ValidateEmail } from '@/utils.js';
import ForgetPassForm from './forms/forgetPassForm';
import { ForgetPassword } from '@/api/endpoints';
import { useTranslation } from 'react-i18next';

const ForgetPass = () => {

    const { t } = useTranslation()
    
    const forgetPassword = (e, data) => {
        e?.preventDefault()

        if (!ValidateEmail(data.email)) return errToast(t("email-not-valid"))

        data.setLoading(true)
        ForgetPassword(data.email).then(res => {
            succToast(t("Code is sent to your email"))
        }).catch(() => {
            errToast(t("failed to send code"))
        }).finally(_ => {
            data.setLoading(false)
        })
    }

    return (
        <ForgetPassForm onSubmit={forgetPassword} />

    );
}

export default memo(ForgetPass);

